<template>
  <VDialog
    v-if="value"
    :value="value"
    @input="$emit('input',$event)"
    :fullscreen="$vuetify.breakpoint.smAndDown"
    :hide-overlay="$vuetify.breakpoint.smAndDown"
    persistent
    max-width="900"
  >
    <VCard class="office-interview-recording ">
      <DialogHeader
        v-if="showOfficeInterviewRecordingCloseButton"
        :title="$t('officeInterviewRecord')"
        @close="cancel"
      />

      <VCardText class="pa-md-5 pa-0">
        <OfficeInterviewRecorderForm
          :vacancy="vacancy"
          @cancel="$emit('input',false)"
          @started="showOfficeInterviewRecordingCloseButton = false"
          @stopped="officeInterviewRecordingStopped"
          @error="officeInterviewRecordingErrored"
        />
      </VCardText>
    </VCard>
  </VDialog>
</template>
<script>
import InterviewsQuotaExceededCandidate from '@/components/Payment/Quota/InterviewsQuotaExceededCandidate';
import DialogHeader from '../DialogHeader.vue';
import OfficeInterviewRecorderForm from '../OfficeInterview/OfficeInterviewRecorderForm.vue';

export default {
  name: 'VacancyCandidatesKanbanOfficeInterview',
  components: {
    InterviewsQuotaExceededCandidate,
    DialogHeader,
    OfficeInterviewRecorderForm,
  },
  props: {
    value: Boolean,
    vacancy: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      showOfficeInterviewRecordingCloseButton: true,
    };
  },
  methods: {
    officeInterviewRecordingStopped() {
      this.showOfficeInterviewRecordingCloseButton = true;
      this.cancel();
    },
    officeInterviewRecordingErrored() {
      this.showOfficeInterviewRecordingCloseButton = true;
    },
    cancel() {
      this.$emit('input', false);
    },
  },
};
</script>

<i18n locale="en" lang="yaml">
officeInterviewRecord: In-person interview recording
</i18n>

<i18n locale="ru" lang="yaml">
officeInterviewRecord: Запись очного интервью
</i18n>
